type RGB = [number, number, number];

class OrderedColor {
  private readonly alpha: number;
  private readonly basePalette: RGB[];
  private counter = 0;

  constructor(alpha: number = 0.9) {
    this.alpha = alpha;

    this.basePalette = [
      //this.hexToRgb('#e6194b'), // rojo fuerte
      //this.hexToRgb('#ffe119'), // amarillo
      this.hexToRgb('#3cb44b'), // verde
      this.hexToRgb('#0082c8'), // azul
      this.hexToRgb('#f58231'), // naranja
      this.hexToRgb('#911eb4'), // morado
      this.hexToRgb('#46f0f0'), // cian
      this.hexToRgb('#f032e6'), // magenta
      this.hexToRgb('#bcf60c'), // lima
      this.hexToRgb('#008080'), // teal
      this.hexToRgb('#9a6324'), // marrón
      this.hexToRgb('#800000'), // granate
      this.hexToRgb('#aaffc3'), // mint
      this.hexToRgb('#808000'), // oliva
      this.hexToRgb('#ffd8b1'), // melocotón
      this.hexToRgb('#000075'), // azul oscuro
      this.hexToRgb('#808080'), // gris medio
      this.hexToRgb('#ffeef1'), // rosa claro
      this.hexToRgb('#a9a9a9'), // gris
      this.hexToRgb('#ffffff'), // blanco
    ];
  }

  getColor(): string {
    const callNumber = this.counter++;
    const paletteSize = this.basePalette.length;

    const baseIndex = callNumber % paletteSize;
    const cycle = Math.floor(callNumber / paletteSize); // 0,1,2,...

    const [r, g, b] = this.basePalette[baseIndex];

    const factor = [1.0, 0.85, 0.7, 0.55][Math.min(cycle, 3)];

    const rr = Math.round(r * factor);
    const gg = Math.round(g * factor);
    const bb = Math.round(b * factor);

    const aa = Math.round(this.alpha * 255); // alpha 0–1 -> 0–255

    return this.rgbaToHex(rr, gg, bb, aa);
  }

  private hexToRgb(hex: string): RGB {
    const clean = hex.replace('#', '');
    const r = parseInt(clean.substring(0, 2), 16);
    const g = parseInt(clean.substring(2, 4), 16);
    const b = parseInt(clean.substring(4, 6), 16);
    return [r, g, b];
  }

  private rgbaToHex(r: number, g: number, b: number, a: number): string {
    const toHex = (v: number) => v.toString(16).padStart(2, '0');
    return `#${toHex(r)}${toHex(g)}${toHex(b)}${toHex(a)}`;
  }
}

export default OrderedColor;
